module.exports = __webpack_public_path__ + "img/ic_24_fitnessplan_serie.71b83cdd.svg";